import styled from '@emotion/styled';
import { Avatar } from '@mui/material';

const CircularIcon = styled(Avatar)(() => ({
  height: 32,
  width: 32,
  background: '#4DDDB8',
  color: 'white'
}));

export default CircularIcon;
